export default /* @ngInject */ function routes($httpProvider) {
    $httpProvider.defaults.xsrfCookieName = 'csrftoken';
    $httpProvider.defaults.xsrfHeaderName = 'X-CSRFToken';
}



// WEBPACK FOOTER //
// ./config/csrf.js